import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LightAccountService } from '../services/light-account/light-account.service';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate {

  constructor(private router: Router, private lightAccount: LightAccountService) {}

  canActivate(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): boolean {
    // Récupérer l'URL complète actuelle depuis window.location
    // Plus fiable que router.url pour les guards sur routes lazy-loaded
    const fullPath = window.location.pathname.slice(1); // Enlever le slash initial
    // …mais lors d'une navigation interne, window.location est encore l'URL
    // de départ : la destination (state.url) compte aussi (ex. retour d'une
    // page d'inscription vers /base/{slug} une fois connecté).
    const targetPath = (state?.url || '').split(/[?#]/)[0].replace(/^\//, '');
    const isSharedPath = (p: string) =>
      p.startsWith('share') || p.startsWith('base') || p.startsWith('scrap');

    // Permettre l'accès aux routes de partage même si connecté
    // (scrap = site vitrine public /scrap/{slug}, visible aussi en preview
    // par un visiteur connecté au BO)
    if (isSharedPath(fullPath) || isSharedPath(targetPath)) {
      return true;
    }

    // Tunnel d'abonnement lancé par un compte léger connecté (conversion en
    // compte Narrathèque depuis la marketplace) : la navigation porte le
    // setup_token, la page /payment-setup doit s'ouvrir malgré la session.
    if (this.router.getCurrentNavigation()?.extras?.state?.['setup_token']) {
      return true;
    }

    // Pour les autres routes publiques (login, register...), rediriger si connecté
    // (compte léger : marketplace des pages perso, jamais le BO classique)
    if (localStorage.getItem('access_token')) {
      this.router.navigate([this.lightAccount.isLight() ? '/marketplace' : '/chat']);
      return false; // Si l'utilisateur est connecté, redirige vers le tableau de bord
    } else {
      return true;
    }
  }
}
